var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webcli",on:{"click":_vm.onClick}},[_c('div',{staticClass:"webcli-input"},[_c('el-input',{ref:"cliinput",attrs:{"spellcheck":"false","autofocus":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }